/// <reference types="google.maps" />
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Coordinates } from "../../types/Location";
import { Loader } from "@googlemaps/js-api-loader";
import { environment } from "../../../../environments/environment";
import { SiteService } from "../../services/site.service";
import { NotificationService } from 'src/app/common/component/notification/notification.service';

@Component({
  selector: 'app-googlemaps',
  templateUrl: './googlemaps.component.html',
  styleUrls: ['./googlemaps.component.scss']
})
export class GoogleMapsComponent implements OnInit, OnChanges {

  @Input() buttonTrigger: boolean;
  @Input() Coordinates: Coordinates;
  @Input() isReadOnly: boolean;
  @Output() setmapsPopupVisibility: EventEmitter<boolean> = new EventEmitter();
  @Output() savecordinates: EventEmitter<Coordinates> = new EventEmitter();
  mapsPopupVisible: boolean;
  isCancel: boolean;
  map: google.maps.Map;

  constructor(private elementRef: ElementRef,
    private siteSvc: SiteService, private notificationService: NotificationService) {
    this.mapsPopupVisible = false;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['buttonTrigger'] && changes['buttonTrigger']?.previousValue != changes['buttonTrigger']?.currentValue) {
      this.mapsPopupVisible = changes['buttonTrigger']?.currentValue;
      if (this.mapsPopupVisible) this.openPopup();
    }
  }

  openPopup() {
    this.mapsPopupVisible = true;
    this.isCancel = false;
    this.initMap();
  }

  initMap(): void {
    const loader = new Loader({
      apiKey: environment.gmaps,
      version: 'weekly'
    });
    loader.load().then(() => {
      const loc = { lat: this.Coordinates.latitude, lng: this.Coordinates.longitude };
      this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
        center: { lat: this.Coordinates.latitude, lng: this.Coordinates.longitude },
        zoom: 3,
        mapTypeId: 'roadmap'
      });
      // create our info window
      const infoWindow = new google.maps.InfoWindow({
        maxWidth: 350
      });

      // The marker, positioned at loc
      let marker = new google.maps.Marker({
        animation: google.maps.Animation.DROP,
        position: loc
      });

      marker.setMap(this.map);
      if (!this.isReadOnly) {
        this.map.addListener("click", (e) => {
          this.Coordinates.latitude = e.latLng.lat();
          this.Coordinates.longitude = e.latLng.lng();
          marker.setPosition(e.latLng);
        });
      }
    });
  }

  OnCloseClicked() {
    this.setmapsPopupVisibility.emit(false);
  }

  OnSaveClicked() {
    let locationsStr = "locations=" + this.Coordinates.latitude + "," + this.Coordinates.longitude;
    this.siteSvc.GetElevation(locationsStr).subscribe({
      next: data => {
        if (data['results'] && data['results'].length > 0) {
          this.Coordinates.altitude = data['results'][0].elevation * 3.2808;
        }
        this.savecordinates.emit(this.Coordinates);
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Elevation details", error);
      }
    });
  }
}
